import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { TablePagination } from 'modules/_shared/Table/components/TablePagination';
import CustomContainedLoading from 'modules/_shared/components/CustomContainedLoading';
import { useRenumerationModal } from '../context/RenumerationModalContext';
import RangeRow from './RangeRow';
import RangesEmptyState from './RangesEmptyState';
import EntireClassRenumerationPreview from './EntireClassRenumerationPreview';
import RenumerationOverlapWarning from './RenumerationOverlapWarning';

const RangesView: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useRenumerationModal();

  const hasData = data.ranges && data.ranges.length > 0;
  const isEmpty = !data.isLoadingRanges && !hasData;

  if (data.isEntireClassRenumeration) {
    return (
      <div className="range-list position-relative">
        {data.isLoadingRanges && <CustomContainedLoading />}
        {hasData && (
          <EntireClassRenumerationPreview
            ranges={data.ranges}
            totalRanges={data.totalRanges}
            totalShares={
              (data.selectedHoldingClassOption?.sharesCount as number) || 0
            }
          />
        )}
      </div>
    );
  }

  return (
    <>
      {hasData && (
        <div className="range-row__header row g-1">
          <div className="col-2">
            <span className="range-row__col-label">{t('From')}</span>
          </div>
          <div className="col-2">
            <span className="range-row__col-label">{t('To')}</span>
          </div>
          <div className="col-2">
            <span className="range-row__col-label">
              {t('NewFrom')} <span className="text-danger">*</span>
            </span>
          </div>
          <div className="col-2">
            <span className="range-row__col-label">
              {t('NewTo')} <span className="text-danger">*</span>
            </span>
          </div>
          <div className="col-4" />
        </div>
      )}

      <div className="range-list position-relative">
        {data.isLoadingRanges && <CustomContainedLoading />}

        {isEmpty && <RangesEmptyState />}

        {data.ranges.map((range, index) => (
          <div
            className="form-control-wrap range-row__wrap"
            key={`row-${range.key}`}
          >
            <RangeRow index={index} range={range} />
          </div>
        ))}
      </div>

      {data.overlapCount > 0 && <RenumerationOverlapWarning />}

      {hasData && (
        <div className="mt-1">
          <TablePagination
            totalRows={data.totalRanges}
            defaultRowsPerPage={data.rowsPerPage}
            onChangePage={actions.handleChangePage}
            onChangeRowsPerPage={actions.handleChangeRowsPerPage}
          />
        </div>
      )}
    </>
  );
};

export default RangesView;
